if (!customElements.get("popup-element")) {
  class PopupElement extends HTMLElement {
    constructor() {
      super();
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
    }

    connectedCallback() {
      this.closeBtn = this.querySelector(".popup-close");
      this.overlay = this.querySelector(".popup-overlay");

      // Add event listeners for close actions
      if (this.closeBtn) {
        this.closeBtn.addEventListener("click", this.hidePopup);
      }

      if (this.overlay) {
        this.overlay.addEventListener("click", this.hidePopup);
      }

      // Add event listeners to trigger buttons
      document.querySelectorAll("[data-popup-trigger]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.showPopup();
        });
      });
    }

    showPopup() {
      // Ensure that only one popup is visible
      const allPopups = document.querySelectorAll("popup-element");
      allPopups.forEach((popup) => {
        if (popup !== this) {
          popup.classList.add("hidden");
        }
      });
      this.classList.remove("hidden");
    }

    hidePopup() {
      this.classList.add("hidden");
    }
  }

  customElements.define("popup-element", PopupElement);
}
